import { makeStyles } from '@mui/styles';

const modelViewerStyle = makeStyles((theme) => ({
    container: {
        width: '100%',
        height: '100vh',
        position: 'relative',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        overflow: 'hidden',
        boxSizing: 'border-box',   // Include padding/border in dimensions
    },
    canvas: {
      display: 'block',
      width: "100%",
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      background: "#202932",
      zIndex: 1, // Canvas is underneath the sidebar
    },

  navCube: {
    position: "absolute",
    width: "11rem",  // Adjust size as needed
    height: "11rem",
    bottom: "1.5rem",  // Position from bottom
    right: "1.5rem",   // Position from right
    zIndex: 2,      // Ensure it is above other elements
  },
  exitFullscreenButton: {
    position: "absolute !important",
    top: "1.2rem",
    right: "1.2rem",
    color: "#e6e6e6 !important",
    width: "25px",  // Adjust size (reduce from the large default)
    height: "25px",
    zIndex: 100,
    '&:hover': {
        transform: "scale(1.1)",
    },
  },

  treeViewHiddenContent: {
    display: "none", // Hide content when collapsed
  },
  toggleButton: {
    position: "absolute", // Position at the top-right of the sidebar
    top: '2rem',
    left: '1.5rem',
    color: '#fff !important',
    border: "none",
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    zIndex: 200,
    "&:hover": {
        color: "#2196f3",
    },
},


  modal: {
    position: "absolute",
    width:'auto',
    height:'auto',
    borderRadius: "23px",
    paddingLeft: "1.3rem",
    paddingRight: '0.8rem',
    paddingTop: "1rem",
    display: 'flex',
    flexDirection: 'column',
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  modalTitle: {
    fontWeight: 600 + '!important',
    fontSize: "1.1rem !important",
    marginBottom: "12px",
    paddingBottom: '0.5 rem',
  },
  modalCloseButton: {
    position: "absolute",
    color: "#555",
  },
  modalAttribute: {
    paddingTop: '0.2rem',
    fontSize: "0.9rem !important", // Smaller font size for the attributes
    color: 'rgba(34, 44, 55, 0.86)', // Optional: set a darker color for better contrast
  },
  treeViewVisible: {
    display: "block",
    pointerEvents: "auto",
    position: "absolute",
    top: "70px",
    left: "1.5rem",
    width: "362px",
    height: "450px",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    color: 'rgba(11, 33, 56, 0.98)', //text color
    borderRadius: "23px",
    fontFamily: 'Montserrat, Arial, sans-serif',
    fontSize: 15,
    userSelect: 'none',
    mozUserSelect: 'none',
    webkitUserSelect: 'none',
    msUserSelect: 'none',
    transition: "width 0.3s ease-in-out",
    overflowY: "auto",
    overflowX: 'hidden',
    whiteSpace: "nowrap",  // ✅ Prevent text from wrapping
    zIndex: 1000,
    paddingLeft: "1rem",
    '& ul': {
          listStyle: 'none',         // Removes default bullet points
          paddingLeft: '1.75em',     // Adds spacing to the left of list items
          pointerEvents: 'none',     // Disables mouse interactions
          '& li':{
            position: 'relative',
            width: '500px',
            pointerEvents: 'none',
            paddingTop: '3px',
            paddingBottom: '3px',
            verticalAlign: 'middle',
            '& a': {
              backgroundColor: '#eee',
              borderRadius: '50%',
              color: '#000',
              display: 'inline-block',
              height: '1.5em',
              left: '-1.5em',
              position: 'absolute',
              textAlign: 'center',
              textDecoration: 'none',
              width: '1.5em',
              pointerEvents: 'all',
              '&.plus': {
                backgroundColor: '#ded',
                pointerEvents: 'all',
              },
              '&.minus': {
                backgroundColor: '#eee',
                pointerEvents: 'all',
              },
              '&:active': {
                top: '1px',
                pointerEvents: 'all',
              },
            },
            '& span': {
              display: 'inline-block',
              width: 'calc(100% - 50px)',
              paddingLeft: '2px',
              pointerEvents: 'all',
              height: '23px',
              overflow: "hidden",
              textOverflow: "ellipsis",  // ✅ Add "..." when text is too long
                maxWidth: "200px",  // ✅ Ensure a reasonable width
              '&:hover': {
                cursor: 'pointer',
                background: 'rgba(0, 0, 0, 0.05)',
                paddingLeft: '2px',
                pointerEvents: 'all',
              },
            },
          },
        },
        '& .highlighted-node': {
          border: 'black solid 1px',
          background: 'yellow',
          color: 'black',
          paddingLeft: '1px',
          paddingRight: '5px',
          pointerEvents: 'all',
        },
        [theme.breakpoints.down("sm")]: {
          width: '300px',
          height: "350px",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
       },

},
treeViewHidden: {
    display: "none",
},
}));

export default modelViewerStyle;